import React from 'react';
import { connect } from 'react-redux';
import { Title, Modal } from '@common/components';
import { popIn } from '@common/utils/services';
import ServiceForm from '../Form';
import { createService } from '@resources/Service/actions';
import { useIntl } from 'react-intl';

const Create = (props) => {
	const { createService, visible, onCancel } = props;
	const intl = useIntl();
	const handleSubmit = (data) => {
		return createService(data)
			.then((response) => {
				popIn(
					'success',
					intl.formatMessage({
						id: 'message.success.service.create',
						defaultMessage:
							'A new Service has been successfully created',
					})
				);
				onCancel && onCancel();
			})
			.catch((err) => Promise.reject(err));
	};

	return (
		<Modal visible={visible} onCancel={() => onCancel && onCancel()}>
			<Title>
				{intl.formatMessage({
					id: 'common.new.service',
					defaultMessage: 'Create Service',
				})}
			</Title>
			<ServiceForm onSubmit={handleSubmit} {...props} />
		</Modal>
	);
};

const mapStateToProps = ({ organization }) => {
	return {
		organization,
	};
};

export default connect(mapStateToProps, { createService })(Create);
